"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useCheckIsHeaderCell = function (rowIndex, fixedRowCount) { return !!(fixedRowCount > 0 && rowIndex === 0); };
exports.default = useCheckIsHeaderCell;
